import sessionValidation = require("./EventSessionValidationService");
import { IResolvedUser, IUserGroupPickerParams, IAvailableActiveDirectoryRealms, UsernameUtils } from "../components/userGroupPicker";
import { ICrnTermCodePickerParams } from "../components/crnTermCodePicker";
import ko = require("knockout");
import _ = require("underscore");
import moment = require("moment");

export class Util {
    static normalizeGuid(id: string | Guid): string {
        if (id) {
            return id.replace(/\-/ig, "").toLowerCase();
        }
        return <string>id;
    }
    static rollUpValidationRules(q?: IObservableAdminQuestionDto, validations?: IQuestionValidation[]): IQuestionValidation {

        if (!validations && q) {
            validations = q.Question.QuestionValidations;
        }

        var rolledUpValidationRule = new QuestionValidation();
        if (validations) {
            ko.utils.arrayForEach(validations, (item: IQuestionValidation) => {
                $.extend(rolledUpValidationRule, item);
            });
        }
        return rolledUpValidationRule;
    }
}

class Logger {
    static enableLogs = false; // not so chatty right now.
    static log(message?: any) {
        if (this.enableLogs) {
            console.log(message);
        }
    }
}

class ValidationUtil {
    static validateValue(regex: RegExp, val: string, required?: boolean) {
        if (!val) {
            if (required) {
                return false;
            }
            return true;
        }
        return regex.test(val);
    }
}

class SerialGenerator {
    private static current: number = 0;
    static getSerial(): number {
        SerialGenerator.current += 1;
        return SerialGenerator.current;
    }
}
class QuestionValidation implements IQuestionValidation {
    QuestionValidationId: Guid;
    QuestionId: Guid;
    UpperDate: Date;
    LowerDate: Date;
    UpperInt: number;
    LowerInt: number;
    UpperDecimal: number;
    LowerDecimal: number;
    RegexPattern: string;
    TypeSpecificPattern: string;
    TypePatternMetadata: string;
    UpperBytes: number;
    SpecificValidationType: FormBuilder.SpecificValidationType;
    AllowInactive: boolean;
    GradableOnly: boolean;
}
export interface INumberQuestionProperties {
    step: string;
    numberValue?: KnockoutComputed<string>;
}
export class NumberQuestionProperties implements INumberQuestionProperties {
    step: string;
    numberValue: KnockoutComputed<string>;
    hasError: KnockoutComputed<boolean>;
    errorMessage: KnockoutComputed<string>;
    placeholder: KnockoutObservable<string>;

    constructor(q: ObservableAdminQuestionDto) {
        var validation = Util.rollUpValidationRules(q);
        this.placeholder = ko.observable<string>();
        let patternIsValid: (val: string) => boolean;

        let patternErrorMessage: string = null;

        this.step = "any";


        if (validation) {
            if (validation.SpecificValidationType) {
                var validationType = validation.SpecificValidationType;
                var typ = validationType;
                if (validationType === "Integer") {
                    this.step = "1";
                }

                var coerceNumber = (val: string): string => {
                    if (val) {
                        var num: number;
                        if (typ === "Integer") {
                            num = parseInt(val, 10);
                        } else {
                            num = parseFloat(val);
                        }
                        if (!_.isNaN(num)) {
                            Logger.log(`coerced value '${val}' to '${num}'`);
                            return String(num);
                        }
                    }
                    return null;
                };
                this.numberValue = ko.computed<string>(<KnockoutComputedDefine<string>>{
                    read: () => {
                        return coerceNumber(q.singleAnswerValue());
                    },
                    write: (value: string) => {
                        q.singleAnswerValue(coerceNumber(value));
                    }
                });

                // error message
                if (typ === "Integer") {
                    patternErrorMessage = "Please enter a whole number";
                    if (_.isFinite(validation.LowerInt) && _.isFinite(validation.UpperInt)) {
                        patternErrorMessage += ` between the values of ${validation.LowerInt} and ${validation.UpperInt}.`;
                    } else if (_.isFinite(validation.LowerInt)) {
                        patternErrorMessage += ` greater than or equal to ${validation.LowerInt}.`;
                    } else if (_.isFinite(validation.UpperInt)) {
                        patternErrorMessage += ` less than or equal to ${validation.UpperInt}.`;
                    }
                }
                if (typ === "Decimal") {
                    patternErrorMessage = "Please enter a decimal number";
                    if (_.isFinite(validation.LowerDecimal) && _.isFinite(validation.UpperDecimal)) {
                        patternErrorMessage += ` between the values of ${validation.LowerDecimal} and ${validation.UpperDecimal}.`;
                    } else if (_.isFinite(validation.LowerDecimal)) {
                        patternErrorMessage += ` greater than or equal to ${validation.LowerDecimal}.`;
                    } else if (_.isFinite(validation.UpperDecimal)) {
                        patternErrorMessage += ` less than or equal to ${validation.UpperDecimal}.`;
                    }
                }

                patternIsValid = (val: string) => {
                    var pattern: RegExp;
                    if (typ === "Integer") {
                        pattern = /^-?\d+$/;
                    } else {
                        pattern = /^-?\d+(\.\d+)?$/;
                    }
                    if (ValidationUtil.validateValue(pattern, val)) {
                        if (typ === "Integer") {
                            let int = parseInt(val, 10);
                            if (_.isFinite(validation.LowerInt)) {
                                if (int < validation.LowerInt) {
                                    return false;
                                }
                            }
                            if (_.isFinite(validation.UpperInt)) {
                                if (int > validation.UpperInt) {
                                    return false;
                                }
                            }
                        }
                        if (typ === "Decimal") {
                            let dec = parseFloat(val);
                            if (_.isFinite(validation.LowerDecimal)) {
                                if (dec < validation.LowerDecimal) {
                                    return false;
                                }
                            }
                            if (_.isFinite(validation.UpperDecimal)) {
                                if (dec > validation.UpperDecimal) {
                                    return false;
                                }
                            }

                        }

                        return true;
                    }
                    return false;
                };
            }



        }
        if (!this.hasError) {
            this.hasError = ko.pureComputed(() => {
                if (!q.shouldSaveAnswers()) {
                    return false;
                }
                var val = q.singleAnswerValue();
                if (!val) {
                    if (q.Question.IsRequired) {
                        return true;
                    }
                    return false;
                }

                if (patternIsValid) {
                    return !patternIsValid(val);
                }

                return false;
            });
        }

        this.errorMessage = ko.pureComputed(() => {
            var val = q.singleAnswerValue();
            if (!val && q.Question.IsRequired) {
                return "This field is required";
            }
            return patternErrorMessage;
        });
    }

}


export class ChoiceProperties {

    hasError: KnockoutComputed<boolean>;
    errorMessage: KnockoutComputed<string>;


    choices: KnockoutComputed<IEditableQuestionChoice[]>;
    selectedChoice: KnockoutObservable<IEditableQuestionChoice>;
    selectedChoices: KnockoutObservableArray<IEditableQuestionChoice>;
    showOther: KnockoutComputed<boolean>;
    otherValue: KnockoutObservable<string>;

    constructor(q: ObservableAdminQuestionDto) {
        var qt = q.Question.QuestionType;

        var allowMultipleAnswers = (qt === "CheckBoxList" || qt === "SelectList");
        var other = <IEditableQuestionChoice>{
            ChoiceName: "Other",
            DisplayChoiceName: "Other",
            ChoiceValue: "",
            isOther: true,
            DisplayOrder: null,
            QuestionChoiceId: null,
            QuestionId: q.Question.QuestionId,
            Archived: false
        };
        this.choices = ko.pureComputed<IEditableQuestionChoice[]>(() => {
            ko.utils.arrayForEach(q.Question.QuestionChoices, function(item: IQuestionChoice, index: number) {
                item.DisplayChoiceName = item.Archived ? item.ChoiceName + " (archived)" : item.ChoiceName;
            });
            var arr = _.sortBy(q.Question.QuestionChoices, "DisplayOrder");
            if (q.Question.AllowOther) {

                arr.push(other);
            }
            return arr;
        });
        this.otherValue = ko.observable<string>(null);
        this.selectedChoice = ko.observable<IEditableQuestionChoice>(null);
        this.selectedChoices = ko.observableArray<IEditableQuestionChoice>([]);
        this.showOther = ko.pureComputed<boolean>(() => {
            var sc = this.selectedChoice();
            if (sc) {
                if (sc.isOther) {
                    return true;
                }
            }
            var scs = ko.utils.arrayFirst(this.selectedChoices(), (choice: IEditableQuestionChoice) => {
                return choice.isOther;
            });
            if (scs) {
                return true;
            }
            return false;
        });


        if (allowMultipleAnswers) {
            ko.utils.arrayForEach(q.AnswersToSave(), (answer: IObservableAnswerToSave) => {
                var choice = ko.utils.arrayFirst(this.choices(), (ch: IEditableQuestionChoice) => {
                    return (ch.ChoiceValue === answer.AnswerValue());
                });
                if (choice) {
                    this.selectedChoices.push(choice);
                } else if (answer.AnswerValue() && answer.AnswerValue().length && q.Question.AllowOther) {
                    this.selectedChoices.push(other);
                    this.otherValue(answer.AnswerValue());
                }
            });

            ko.computed(() => {
                var answerValues = ko.utils.arrayMap(this.selectedChoices(), (item: IEditableQuestionChoice) => {
                    if (item.isOther) {
                        return this.otherValue();
                    }
                    return item.ChoiceValue;
                });
                var answers = answerValues.map((av: string) => {
                    return new ObservableAnswerToSave(<IAnswerToSave>{
                        AnswerValue: av,
                        QuestionId: q.Question.QuestionId,
                        QuestionFieldName: null
                    });
                });
                Logger.log(`Writing answers ${answerValues.join(", ")} to AnswersToSave for question ${q.Question.FieldName}`);
                q.AnswersToSave(answers);
            });

        } else {
            var val = q.singleAnswerValue();
            if (val && val.length) {
                var firstChoice = ko.utils.arrayFirst(this.choices(), (choice: IEditableQuestionChoice) => {
                    return choice.ChoiceValue === val;
                });
                if (firstChoice) {
                    this.selectedChoice(firstChoice);
                } else {
                    if (q.Question.AllowOther) {
                        this.selectedChoice(other);
                        this.otherValue(val);
                    }
                }
            }
            ko.computed(() => {
                var sChoice = this.selectedChoice();
                if (sChoice) {
                    if (sChoice.isOther) {
                        q.singleAnswerValue(this.otherValue());
                    } else {
                        q.singleAnswerValue(sChoice.ChoiceValue);
                    }
                } else {
                    q.singleAnswerValue(null);
                }
            });
        }
        if (!this.hasError) {
            this.hasError = ko.pureComputed(() => {
                if (!q.shouldSaveAnswers()) {
                    return false;
                }
                var val = q.singleAnswerValue();
                if (!val) {
                    if (q.Question.IsRequired) {
                        return true;
                    }
                    return false;
                }

                return false;
            });
        }

        this.errorMessage = ko.pureComputed(() => {
            var val = q.singleAnswerValue();
            if (!val && q.Question.IsRequired) {
                return "This field is required";
            }
            return null;
        });

    }
}

export interface IEventSessionProperties {
    allowMultipleSelection: boolean;
    sessions: KnockoutComputed<IEditEventSessionDto[]>;
    selectedSession: KnockoutObservable<IEditEventSessionDto>;
    selectedSessions: KnockoutObservableArray<IEditEventSessionDto>;
}

export interface IEditEventSessionDto extends IEventSessionDto {
    validationResult?: KnockoutObservable<sessionValidation.IEventSessionEvaluationResultDto>;
    hasWarning: KnockoutComputed<boolean>;
}

class EventSessionProperties implements IEventSessionProperties {
    allowMultipleSelection: boolean;
    sessions: KnockoutComputed<IEditEventSessionDto[]>;
    selectedSession: KnockoutObservable<IEditEventSessionDto>;
    selectedSessions: KnockoutObservableArray<IEditEventSessionDto>;
    constructor(q: ObservableAdminQuestionDto, eventSessionCategories: IEventSessionCategoryDto[], eventSessions: IEditEventSessionDto[], formResponseId: Guid) {

        var categoryId = Util.normalizeGuid(q.Question.EventSessionCategoryId);
        var category = ko.utils.arrayFirst(eventSessionCategories, (cat: IEventSessionCategoryDto) => {
            return Util.normalizeGuid(cat.Id) === categoryId;
        });
        
        var allowMultipleSessionSelection = false;
        if (category) {
            category.AllowMultipleSessionSelection;
        } else {
            console.error(`WARNING: could not retrieve category for categoryId of ${categoryId} when creating EventSessionProperties`);
        }

        var filteredSessions = ko.utils.arrayFilter(eventSessions, (sess: IEditEventSessionDto) => { return Util.normalizeGuid(sess.EventSessionCategoryId) === categoryId; });
        var validationService = new sessionValidation.Service();
        ko.utils.arrayForEach(filteredSessions, (fs) => {
            fs.validationResult = ko.observable(null);
            fs.hasWarning = ko.computed(() => {
                if (fs.validationResult()) {
                    return !fs.validationResult().IsValid;
                }
                return false;
            });

            validationService.validateEventSession(formResponseId, fs.Id).then((validationResult) => {
                fs.validationResult(validationResult);
            });
        });

        this.allowMultipleSelection = allowMultipleSessionSelection;
        this.selectedSession = ko.observable<IEditEventSessionDto>(null);
        this.selectedSessions = ko.observableArray<IEditEventSessionDto>([]);
        this.sessions = ko.pureComputed<IEditEventSessionDto[]>(() => {
            var arr = _.sortBy(filteredSessions, "DisplayOrder");
            return arr;
        });



        if (allowMultipleSessionSelection) {
            ko.utils.arrayForEach(q.AnswersToSave(), (answer: IObservableAnswerToSave) => {
                var answerValue = Util.normalizeGuid(answer.AnswerValue());
                var session = ko.utils.arrayFirst(this.sessions(), (ch: IEditEventSessionDto) => {
                    return (Util.normalizeGuid(ch.Id) === answerValue);
                });
                if (session) {
                    this.selectedSessions.push(session);
                }
            });

            ko.computed(() => {
                var answerValues = ko.utils.arrayMap(this.selectedSessions(), (item: IEditEventSessionDto) => {
                    return Util.normalizeGuid(item.Id);
                });
                var answers = answerValues.map((av: string) => {
                    return new ObservableAnswerToSave(<IAnswerToSave>{
                        AnswerValue: av,
                        QuestionId: q.Question.QuestionId,
                        QuestionFieldName: null
                    });
                });
                Logger.log(`Writing answers ${answerValues.join(", ")} to AnswersToSave for question ${q.Question.FieldName}`);
                q.AnswersToSave(answers);
            });

        } else {
            let singleSessionVal = Util.normalizeGuid(q.singleAnswerValue());
            if (singleSessionVal && singleSessionVal.length) {
                let firstSession = ko.utils.arrayFirst(this.sessions(), (choice: IEditEventSessionDto) => {
                    return Util.normalizeGuid(choice.Id) === singleSessionVal;
                });
                if (firstSession) {
                    this.selectedSession(firstSession);
                }
            }
            ko.computed(() => {
                var sSession = this.selectedSession();
                if (sSession) {
                    q.singleAnswerValue(Util.normalizeGuid(sSession.Id));

                } else {
                    q.singleAnswerValue(null);
                }
            });
        }

    }
}



export class DateTimeQuestionProperties {
    hasError: KnockoutComputed<boolean>;
    errorMessage: KnockoutComputed<string>;
    placeholder: KnockoutObservable<string>;

    public dateFormatType: string;

    public dateTimeValue: KnockoutComputed<string>;

    private specificValidationType: FormBuilder.SpecificValidationType;
    constructor(q: ObservableAdminQuestionDto) {
        var validation = Util.rollUpValidationRules(q);

        if (validation) {
            this.specificValidationType = validation.SpecificValidationType;
        }

        //Monday, April 25, 2011 12:00:00 AM
        var serverDateFormat = "dddd, MMMM D, YYYY h:mm:SS A";
        var type : FormBuilder.SpecificValidationType = "DateTime";
        if (this.specificValidationType) {
            type = this.specificValidationType;
        }
        Logger.log("type is: " + type + " (" + typeof (type) + ")");

        var browserFormat: string = null;

        if (type === "Date") {
            this.dateFormatType = "Date";
            browserFormat = "YYYY-MM-DD";
        } else if (type === "DateTime") {
            this.dateFormatType = "DateTime";
            browserFormat = "YYYY-MM-DDThh:mm";
        } else if (type === "Time") {
            this.dateFormatType = "Time";
            browserFormat = "hh:mm";
        }

        var momentValue = ko.pureComputed(() => {
            if (q.singleAnswerValue()) {
                var m = moment(q.singleAnswerValue(), serverDateFormat);
                if (m.isValid()) {
                    return m;
                }
            }
            return null;
        });

        if (browserFormat) {
            this.dateTimeValue = ko.computed<string>(<KnockoutComputedDefine<string>>{
                read: () => {
                    Logger.log(`Reading value: '${q.singleAnswerValue()}'`);
                    var m = momentValue();
                    if (m && m.isValid()) {
                        return m.format(browserFormat);
                    }
                    return null;
                },
                write: (value: string) => {
                    if (value) {
                        var m = moment(value, browserFormat);
                        if (m.isValid()) {
                            q.singleAnswerValue(m.format(serverDateFormat));
                        } else {
                            q.singleAnswerValue(null);
                        }
                    } else {
                        q.singleAnswerValue(null);
                    }
                }
            });
        }


        this.placeholder = ko.observable<string>();
        let patternIsValid: (val: moment.Moment) => boolean;

        let patternErrorMessage: string = null;

        if (validation) {
            if (validation.SpecificValidationType) {

                let dateFormat = "";
                if (type === "Date") {
                    patternErrorMessage = "Please enter a valid date";
                    dateFormat = "YYYY-MM-DD";
                } else if (type === "DateTime") {
                    patternErrorMessage = "Please enter a valid date";
                    dateFormat = "YYYY-MM-DD hh:mm a";
                } else if (type === "Time") {
                    patternErrorMessage = "Please enter a valid time";
                    dateFormat = "hh:mm a";
                }

                if (validation.LowerDate && validation.UpperDate) {
                    patternErrorMessage += ` between ${moment(validation.LowerDate).format(dateFormat)} and ${moment(validation.UpperDate).format(dateFormat)}.`;
                } else if (validation.LowerDate) {
                    patternErrorMessage += ` on or after ${moment(validation.LowerDate).format(dateFormat)}.`;
                } else if (validation.UpperDate) {
                    patternErrorMessage += ` on or before ${moment(validation.UpperDate).format(dateFormat)}.`;
                }


                if (type === "Date" || type === "DateTime") {



                    patternIsValid = (val: moment.Moment) => {
                        if (validation.LowerDate) {
                            if (val.isBefore(validation.LowerDate)) {
                                return false;
                            }
                        }
                        if (validation.UpperDate) {
                            if (val.isAfter(validation.UpperDate)) {
                                return false;
                            }
                        }
                        return true;
                    }
                }
                if (type === "Time") {
                    var minutesOfDay = (m: moment.Moment) => {
                        return m.minutes() + m.hours() * 60;
                    }
                    patternIsValid = (val: moment.Moment) => {
                        if (validation.LowerDate) {
                            if (minutesOfDay(val) < minutesOfDay(moment(validation.LowerDate))) {
                                return false;
                            }
                        }
                        if (validation.UpperDate) {
                            if (minutesOfDay(val) > minutesOfDay(moment(validation.UpperDate))) {
                                return false;
                            }
                        }
                        return true;
                    };
                }



            }

        }
        if (!this.hasError) {
            this.hasError = ko.pureComputed(() => {
                if (!q.shouldSaveAnswers()) {
                    return false;
                }

                var val = momentValue();
                if (!val) {
                    if (q.Question.IsRequired) {
                        return true;
                    }
                    return false;
                }

                if (patternIsValid) {
                    return !patternIsValid(val);
                }

                return false;
            });
        }

        this.errorMessage = ko.pureComputed(() => {
            var val = q.singleAnswerValue();
            if (!val && q.Question.IsRequired) {
                return "This field is required";
            }
            return patternErrorMessage;
        });
    }
}
export class SingleLineTextQuestionProperties {
    hasError: KnockoutComputed<boolean>;
    errorMessage: KnockoutComputed<string>;
    placeholder: KnockoutObservable<string>;

    constructor(q: ObservableAdminQuestionDto) {
        var validation = Util.rollUpValidationRules(q);
        this.placeholder = ko.observable<string>();
        let patternIsValid: (val: string) => boolean;

        let patternErrorMessage: string = null;

        if (validation) {
            if (validation.SpecificValidationType) {
                var validationType = validation.SpecificValidationType;
                if (validationType === "EmailAddress") {
                    this.placeholder("user@example.com");
                    patternIsValid = (val: string) => {
                        return ValidationUtil.validateValue(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, val);
                    };
                    patternErrorMessage = "Please enter a valid email address (user@example.com).";
                }
                if (validationType === "PostalCode") {
                    this.placeholder("xxxxx(-xxxx)");
                    patternIsValid = (val) => {
                        return ValidationUtil.validateValue(/^\d{5}([\-]\d{4})?$/, val);
                    };
                    patternErrorMessage = "Please enter a valid U.S. zip code (xxxxx or xxxxx-xxxx)";
                }
                if (validationType === "Telephone") {
                    this.placeholder("xxx-xxx-xxxx");
                    patternIsValid = (val) => {
                        val = val.replace(/\s+/g, "");
                        return val.length > 9 && ValidationUtil.validateValue(/^(1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/, val);
                    }
                    patternErrorMessage = "Please enter a valid U.S. phone number (xxx-xxx-xxxx)";
                }
                if (validationType === "Url") {
                    this.placeholder("http://www.example.com");
                    patternErrorMessage = "Please enter a valid URL";
                    patternIsValid = (val) => {
                        return ValidationUtil.validateValue(/^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, val);
                    }
                }

            }
            if (validation.RegexPattern) {
                patternIsValid = (val) => {
                    return ValidationUtil.validateValue(new RegExp(validation.RegexPattern), val);
                }
            }


        }
        if (!this.hasError) {
            this.hasError = ko.pureComputed(() => {
                if (!q.shouldSaveAnswers()) {
                    return false;
                }

                var val = q.singleAnswerValue();
                if (!val) {
                    if (q.Question.IsRequired) {
                        return true;
                    }
                    return false;
                }

                if (patternIsValid) {
                    return !patternIsValid(val);
                }

                return false;
            });
        }

        this.errorMessage = ko.pureComputed(() => {
            var val = q.singleAnswerValue();
            if (!val && q.Question.IsRequired) {
                return "This field is required";
            }
            return patternErrorMessage;
        });
    }
}
export class MultiLineTextQuestionProperties {
    hasError: KnockoutComputed<boolean>;
    errorMessage: KnockoutComputed<string>;
    hasWordCount: KnockoutObservable<boolean>;
    wordCount: KnockoutComputed<string>;

    constructor(q: ObservableAdminQuestionDto) {
        var validation = Util.rollUpValidationRules(q);
        let patternIsValid: (val: string) => boolean;
        let wordCountIsValid: (val: string) => boolean;
        this.hasWordCount = ko.observable(false);
        
        let patternErrorMessage: string = null;

        if (validation) {
            if (validation.UpperInt !== null) {
                this.hasWordCount(true);

                wordCountIsValid = (val) => {
                    patternErrorMessage = `Please enter ${validation.UpperInt} words or less.`;
                    let matches = val?.match(/\S+/g);
                    return !matches || matches.length <= validation.UpperInt;
                }
            }

            if (validation.RegexPattern) {
                patternErrorMessage = "Format is invalid";
                patternIsValid = (val) => {
                    return ValidationUtil.validateValue(new RegExp(validation.RegexPattern), val);
                }
            }
        }

        if (!this.hasError) {
            this.hasError = ko.pureComputed(() => {
                if (!q.shouldSaveAnswers()) {
                    return false;
                }

                var val = q.singleAnswerValue();
                if (!val) {
                    if (q.Question.IsRequired) {
                        return true;
                    }
                    return false;
                }

                if (wordCountIsValid) {
                    if (!wordCountIsValid(val))
                        return true;
                }

                if (patternIsValid) {
                    return !patternIsValid(val);
                }

                return false;
            });
        }

        if (!this.wordCount) {
            this.wordCount = ko.pureComputed(() => {
                if (!this.hasWordCount())
                    return null;

                let val = q.singleAnswerValue();
                let matches = val?.match(/\S+/g);
                return `${matches ? matches.length : 0}/${validation.UpperInt} words`;
            });
        }

        this.errorMessage = ko.pureComputed(() => {
            var val = q.singleAnswerValue();
            if (!val && q.Question.IsRequired) {
                return "This field is required";
            }
            return patternErrorMessage;
        });
    }
}

export class PersonAttributeQuestionProperties {
    personAttributeMergeFieldText: KnockoutComputed<string>;
    constructor(q: ObservableAdminQuestionDto) {
        this.personAttributeMergeFieldText = ko.pureComputed(() => {
            if (q && q.Question && q.Question.QuestionValidations) {
                var rolledUpRule = Util.rollUpValidationRules(q);
                return rolledUpRule.TypePatternMetadata;
            }
            return null;
        });
    }
}

export class NetIdQuestionProperties {
    hasError: KnockoutComputed<boolean>;
    errorMessage: KnockoutComputed<string>;


    resolvedUser: KnockoutObservable<IResolvedUser>;
    netId: KnockoutObservable<string>;

    pickerOptions: IUserGroupPickerParams;

    constructor(q: ObservableAdminQuestionDto, adRealms: IAvailableActiveDirectoryRealms) {
        this.resolvedUser = ko.observable<IResolvedUser>(null);
        this.netId = ko.observable<string>(q.singleAnswerValue());

        ko.computed(() => {
            let ro = this.resolvedUser();
            if (ro) {
                q.singleAnswerValue(`${ro.LookupKey}@${ro.Realm}`);
            } else {
                q.singleAnswerValue(null);
            }
        });


        this.pickerOptions = <IUserGroupPickerParams>{
            shouldHaveAddButton: false,
            netId: this.netId,
            resolvedUser: this.resolvedUser,
            netIdFocused: ko.observable(false),
            placeholderText: ko.observable(""),
            resolutionIdSuffix: ko.observable(q.Question.QuestionId),
        };


        let rule = Util.rollUpValidationRules(q);
        let specificValidationType = rule.SpecificValidationType;
        let showRealms = specificValidationType !== "SpecificActiveDirectory";
        if (!specificValidationType) {
            showRealms = false;
        }
        let existingRealm = adRealms.DefaultRealm;
        let netId = this.netId();
        if (netId) {
            let parsedRealm = UsernameUtils.parseRealm(netId);
            if (parsedRealm) {
                existingRealm = parsedRealm;
            }
        }
        if (specificValidationType === "SpecificActiveDirectory" && rule.TypePatternMetadata) {
            existingRealm = rule.TypePatternMetadata;
        }

        if (showRealms) {
            this.pickerOptions.realms = adRealms.Realms;
        } else {
            this.pickerOptions.forcedRealm = existingRealm;
        }

        Logger.log(`netid passed to picker is: ${this.pickerOptions.netId()}`);


        if (!this.hasError) {
            this.hasError = ko.pureComputed(() => {
                if (!q.shouldSaveAnswers()) {
                    return false;
                }

                var val = q.singleAnswerValue();
                if (!val) {
                    if (q.Question.IsRequired) {
                        return true;
                    }
                    return false;
                }


                return false;
            });
        }

        this.errorMessage = ko.pureComputed(() => {
            var val = q.singleAnswerValue();
            if (!val && q.Question.IsRequired) {
                return "This field is required";
            }
            return null;
        });
    }
}

export class CourseCrnQuestionProperties {
    selectedCrn: KnockoutObservable<string>;
    selectedTerm: KnockoutObservable<string>;
    hasError: KnockoutComputed<boolean>;
    errorMessage: KnockoutComputed<string>;
    resolvedCampusSection: KnockoutObservable<ICampusSection>;
    pickerOptions: ICrnTermCodePickerParams;

    parseCourseCrnAnswerValue(answerValue: string) {
        Logger.log(`parsing course crn answer value of "${answerValue}"`);
        if (answerValue && answerValue.length) {
            var values = answerValue.split("|");
            if (values && values.length === 2) {
                return new CourseCrnAnswerValue(values[0], values[1]);
            }
        }
        return new CourseCrnAnswerValue(null, null);
    }

    constructor(q: ObservableAdminQuestionDto, qm: ICourseCrnQuestionModel) {
        let parsedAnswerValue = this.parseCourseCrnAnswerValue(q.singleAnswerValue());

        this.selectedCrn = ko.observable(parsedAnswerValue.crn);
        this.selectedTerm = ko.observable(parsedAnswerValue.termCode);
        this.resolvedCampusSection = ko.observable(null);

        ko.computed(() => {
            let rcs = this.resolvedCampusSection();
            if (rcs) {
                q.singleAnswerValue(`${rcs.Crn}|${rcs.TermCode}`);
            } else {
                q.singleAnswerValue(null);
            }
        });

        let rule = Util.rollUpValidationRules(q);
        let specificValidationType = rule.SpecificValidationType;
        if (!specificValidationType) {
            specificValidationType = "AnyTerm";
        }

        let termOptions = [] as ITextValue[];
        let disableValidation = false;
        let forcedTerm = null as ITextValue;

        if (specificValidationType === "AnyTerm") {
            let campus = rule.TypePatternMetadata;
            if (!qm.TermDefaults[campus])
                campus = qm.FormGroupCampus;
            if (!qm.TermDefaults[campus])
                campus = "UIUC";
            
            termOptions = _.map(_.filter(qm.AllTerms, x => x.Campus === campus), x => { return { Value: x.TermCode, Text: x.TermDescription } });
            if (!this.selectedTerm()) {
                this.selectedTerm(qm.TermDefaults[campus]?.TermCode);
            }
            disableValidation = false;
        } else if (specificValidationType === "AnyTermPeriodAttribute") {
            if (qm.IsAssociatedWithResponse) {
                var validTermCodes = _.chain(qm.TermPeriodAttributeMapping).keys().filter(id => id in qm.AttributeValueMapping).map(id => qm.AttributeValueMapping[id]).value();
                termOptions = _.chain(qm.AllTerms).filter(x => _.any(validTermCodes, y => y === x.TermCode)).map(x => { return { Value: x.TermCode, Text: x.TermDescription } as ITextValue}).value();
            } else {
                termOptions = _.map(qm.TermPeriodAttributeMapping, (v, k) => { return { Value: null, Text: `Sample Term For ${v}` } as ITextValue});
            }

            let existingSelected = _.find(termOptions, x => x.Value === this.selectedTerm());
            if (!existingSelected && termOptions.length) {
                this.selectedTerm(termOptions[0].Value);
            }
            disableValidation = !qm.IsAssociatedWithResponse;
        } else if (specificValidationType === "CurrentTerm") {
            forcedTerm = { Text: "[not found]", Value: null };

            if (!this.selectedTerm()) {
                let currentTerm = _.find(qm.AllTerms, x => x.TermCode === qm.CurrentTerm);
                if (currentTerm) {
                    forcedTerm = { Text: currentTerm.TermDescription, Value: currentTerm.TermCode } as ITextValue;
                }
            } else {
                let st = _.find(qm.AllTerms, x => x.TermCode === this.selectedTerm());
                if (st) {
                    forcedTerm = { Text: st.TermDescription, Value: st.TermCode } as ITextValue;
                }
            }

            disableValidation = forcedTerm.Value ? false : true;
        } else if (specificValidationType === "SpecificTermPeriodAttribute") {
            forcedTerm = { Text: "[not found]", Value: null };

            let id = rule.TypePatternMetadata;

            if (qm.IsAssociatedWithResponse) {
                let specificTerm = null as ICampusTermListing;
                if (id in qm.AttributeValueMapping) {
                    specificTerm = _.find(qm.AllTerms, x => x.TermCode === qm.AttributeValueMapping[id]);
                }

                if (specificTerm) {
                    forcedTerm = { Text: specificTerm.TermDescription, Value: specificTerm.TermCode } as ITextValue;
                }
            } else {
                if (id in qm.TermPeriodAttributeMapping) {
                    forcedTerm = { Text: `Sample Term For ${qm.TermPeriodAttributeMapping[id]}`, Value: null } as ITextValue;
                }
            }

            disableValidation = !qm.IsAssociatedWithResponse;
        }

        this.pickerOptions = <ICrnTermCodePickerParams>{
            crn: this.selectedCrn,
            selectedTerm: this.selectedTerm,
            resolvedCampusSection: this.resolvedCampusSection,
            terms: termOptions,
            disableValidation: disableValidation,
            forcedTerm: forcedTerm,
            inputGroupLabel: ko.observable(q.Question.QuestionText),
            resolutionIdSuffix: ko.observable(q.Question.QuestionId.toLowerCase())
        };

        if (!this.hasError) {
            this.hasError = ko.pureComputed(() => {
                if (!q.shouldSaveAnswers()) {
                    return false;
                }

                var val = q.singleAnswerValue();
                if (!val) {
                    if (q.Question.IsRequired) {
                        return true;
                    }
                    return false;
                }

                let rcs = this.resolvedCampusSection();

                if (rcs) {
                    if (!rcs.Active && !rule.AllowInactive) {
                        return true;
                    }

                    if (!rcs.Gradable && rule.GradableOnly) {
                        return true;
                    }
                }

                return false;
            });
        }

        this.errorMessage = ko.pureComputed(() => {
            var val = q.singleAnswerValue();

            if (!val && this.selectedCrn()) {
                return "Please enter a valid CRN and term code";
            }

            if (!val && q.Question.IsRequired) {
                return "This field is required";
            }

            let rcs = this.resolvedCampusSection();

            if (rcs) {
                if (!rcs.Active && !rule.AllowInactive) {
                    return "Section is not active and question does not allow inactive sections";
                }

                if (!rcs.Gradable && rule.GradableOnly) {
                    return "Section is not gradable and question only allows gradable sections";
                }
            }
            return null;
        });
    }
}

export class FileUploadProperties {
    removeDocument(): void { }

    document: KnockoutComputed<IDocumentDto>;
    documentDownloadUrl: KnockoutComputed<string>;

    uploadInputName: string;

    constructor(q: ObservableAdminQuestionDto, documents: IDocumentDto[], downloadFileUrl: string) {
        this.document = ko.pureComputed<IDocumentDto>(() => {
            var id = Util.normalizeGuid(q.singleAnswerValue());
            return ko.utils.arrayFirst(documents, (doc: IDocumentDto) => { return Util.normalizeGuid(doc.DocumentId) === id; });
        });
        this.documentDownloadUrl = ko.pureComputed<string>(() => {
            var doc = this.document();
            if (doc) {
                var paramCharacter = "?";
                if (downloadFileUrl.indexOf("?") > -1) {
                    paramCharacter = "&";
                }
                return `${downloadFileUrl}${paramCharacter}fileId=${Util.normalizeGuid(doc.DocumentId)}`;
            }
            return null;
        });
        this.removeDocument = () => {
            q.singleAnswerValue(this.uploadInputName);
        };


        this.uploadInputName = `fileUpload_${SerialGenerator.getSerial()}`;

        if (!q.singleAnswerValue()) {
            q.singleAnswerValue(this.uploadInputName);
        }
    }
}

export interface ICheckboxQuestionProperties {
    booleanValue: KnockoutComputed<boolean>
}

export interface IMultipleQuestionAnswerProperties {
    answerRows: KnockoutComputed<MultipleQuestionAnswerRow[]>;
    addRow(): void;
}

class MultipleQuestionAnswerProperties implements IMultipleQuestionAnswerProperties {

    answerRows: KnockoutComputed<MultipleQuestionAnswerRow[]>;

    q: ObservableAdminQuestionDto;

    ensureCompositeStructure() {
        var q = this.q;
        if (!q.AnswersToSave) {
            q.AnswersToSave = ko.observableArray<IObservableAnswerToSave>();
        }
        if (q.AnswersToSave().length < 1) {
            q.AnswersToSave()[0] = <IObservableAnswerToSave>{
                AnswerValue: ko.observable(null),
                QuestionId: q.Question.QuestionId,
                Rows: ko.observableArray<IObservableCompositeAnswerRow>()
            }
        }

        var parentAnswer = q.AnswersToSave()[0];
        if (!parentAnswer.Rows) {
            parentAnswer.Rows = ko.observableArray<IObservableCompositeAnswerRow>();
        }

        return parentAnswer;
    }
    addRow() {
        if (!this.ensureCompositeStructure) {
            debugger;
        }
        var parentAnswer = this.ensureCompositeStructure();

        var row = new ObservableCompositeAnswerRow();

        var observableAnswers = this.q.Question.Questions.map((cq: ISurveyQuestion) => {
            return new ObservableAnswerToSave(<IAnswerToSave>{
                AnswerValue: null,
                QuestionId: cq.QuestionId
            });
        });

        row.Answers(observableAnswers);

        parentAnswer.Rows.push(row);
    }

    createCompositeAnswerRows(allowZeroRows: boolean) {


        var previousRows: MultipleQuestionAnswerRow[] = null;
        var compareAndUpdateParentAnswers = (previousAnswers: IObservableAnswerToSave[], newAnswers: IObservableAnswerToSave[], fullAnswerArray: KnockoutObservableArray<IObservableAnswerToSave>): IObservableAnswerToSave[] => {



            // added answers
            var addedAnswers: IObservableAnswerToSave[] = [];
            var removedAnswers: IObservableAnswerToSave[] = [];

            ko.utils.arrayForEach(previousAnswers, (pa) => {
                if (!ko.utils.arrayFirst(newAnswers, (na) => { return na === pa; })) {
                    removedAnswers.push(pa);
                }
            });
            ko.utils.arrayForEach(newAnswers, (na) => {
                if (!ko.utils.arrayFirst(previousAnswers, (pa) => { return na === pa; })) {
                    addedAnswers.push(na);
                }
            });

            ko.utils.arrayForEach(addedAnswers, (aa) => {
                fullAnswerArray.push(aa);
            });
            ko.utils.arrayForEach(removedAnswers, (ra) => {
                fullAnswerArray.remove(ra);
            });

            return newAnswers;

        };
        return ko.computed<MultipleQuestionAnswerRow[]>(<KnockoutComputedDefine<MultipleQuestionAnswerRow[]>>{
            read: () => {

                var parentAnswer = this.ensureCompositeStructure();
                if (!allowZeroRows && !parentAnswer.Rows().length) {
                    this.addRow();
                }

                var q = this.q;

                var parentAnswerRowsLength = parentAnswer.Rows().length;
                if (previousRows == null || (previousRows.length !== parentAnswerRowsLength)) {
                    if (previousRows === null) {
                        Logger.log(`previous rows for ${q.Question.FieldName} are null.  Creating parentAnswerRows...`);
                    } else {
                        Logger.log(`previousRows for ${q.Question.FieldName} has ${previousRows.length} rows and the new parentAnswer.Rows() has a length of ${parentAnswerRowsLength}.  Recreating rows.`);
                    }
                    previousRows = parentAnswer.Rows().map((r: IObservableCompositeAnswerRow) => {
                        var answers = r.Answers();
                        return new MultipleQuestionAnswerRow(
                            () => {
                                parentAnswer.Rows.remove(r);
                            },
                            q.Question.Questions.map((cq: ISurveyQuestion) => {
                                var qid = Util.normalizeGuid(cq.QuestionId);
                                var childAnswers: IObservableAnswerToSave[] = ko.utils.arrayFilter(answers, (cans: IObservableAnswerToSave) => {
                                    return Util.normalizeGuid(cans.QuestionId) === qid;
                                });

                                var observableChildAnswers = ko.observableArray(childAnswers);
                                observableChildAnswers.subscribe((nv) => {
                                    childAnswers = compareAndUpdateParentAnswers(childAnswers, nv, r.Answers);
                                });

                                return new ObservableAdminQuestionDto(cq, q.pageData, observableChildAnswers);
                            }));
                    });
                    return previousRows;
                } else {
                    Logger.log(`count of current rows is no different than previous row count of ${parentAnswerRowsLength}.  Returning cached rows.`);
                    return previousRows;
                }
            }
        });
    }


    constructor(q: ObservableAdminQuestionDto) {
        this.q = q;
        this.answerRows = this.createCompositeAnswerRows(false);
        if (!q.pageData) {
            debugger;
        }
    }

}

export interface IGuestQuestionAnswerProperties extends IMultipleQuestionAnswerProperties {
    guestCount: KnockoutComputed<string>;
    supportsCompositeQuestions: boolean;
    hasError: KnockoutComputed<boolean>;
    errorMessage: KnockoutComputed<string>;

}

class GuestQuestionAnswerProperties extends MultipleQuestionAnswerProperties implements IGuestQuestionAnswerProperties {
    hasError: KnockoutComputed<boolean>;
    errorMessage: KnockoutComputed<string>;


    guestCount: KnockoutComputed<string>;
    supportsCompositeQuestions: boolean;

    constructor(q: ObservableAdminQuestionDto, specificValidationType: FormBuilder.SpecificValidationType) {
        super(q);
        this.answerRows = this.createCompositeAnswerRows(true);
        this.guestCount = ko.computed<string>(<KnockoutComputedDefine<string>>{
            read: () => { return q.singleAnswerValue(); },
            write: (value: string) => {
                q.singleAnswerValue(value);
            }
        });
        this.supportsCompositeQuestions = (specificValidationType === "GuestCountWithDetails");

        var numericGuestCount = ko.pureComputed<number>(() => {
            if (this.guestCount) {
                var val = this.guestCount();
                if (val) {
                    var i = parseInt(val, 10);
                    if (_.isFinite(i) && i >= 0) {
                        return i;
                    }
                }
            }
            return 0;
        });
        // watch numeric guest count for rows
        ko.computed(() => {
            var count = numericGuestCount();
            var rows = this.answerRows();
            var i: number;
            if (rows.length > count) {
                for (i = (rows.length - 1); i >= count; i -= 1) {
                    rows[i].remove();
                }
            } else if (rows.length < count) {
                for (i = rows.length; i < count; i += 1) {
                    this.addRow();
                }
            }

        });




        let patternIsValid: (val: string) => boolean;

        let patternErrorMessage: string = null;


        var validation = Util.rollUpValidationRules(q);
        patternErrorMessage = "Please enter a number";
        if (_.isFinite(validation.LowerInt) && _.isFinite(validation.UpperInt)) {
            patternErrorMessage += ` between the values of ${validation.LowerInt} and ${validation.UpperInt}.`;
        } else if (_.isFinite(validation.LowerInt)) {
            patternErrorMessage += ` greater than or equal to ${validation.LowerInt}.`;
        } else if (_.isFinite(validation.UpperInt)) {
            patternErrorMessage += ` less than or equal to ${validation.UpperInt}.`;
        }

        patternIsValid = (val: string) => {
            var pattern = /^-?\d+$/;

            if (ValidationUtil.validateValue(pattern, val)) {

                let int = parseInt(val, 10);
                if (_.isFinite(validation.LowerInt)) {
                    if (int < validation.LowerInt) {
                        return false;
                    }
                }
                if (_.isFinite(validation.UpperInt)) {
                    if (int > validation.UpperInt) {
                        return false;
                    }
                }


                return true;
            }
            return false;
        };



        if (!this.hasError) {
            this.hasError = ko.pureComputed(() => {
                if (!q.shouldSaveAnswers()) {
                    return false;
                }
                var val = q.singleAnswerValue();
                if (!val) {
                    if (q.Question.IsRequired) {
                        return true;
                    }
                    return false;
                }

                if (patternIsValid) {
                    return !patternIsValid(val);
                }

                return false;
            });
        }

        this.errorMessage = ko.pureComputed(() => {
            var val = q.singleAnswerValue();
            if (!val && q.Question.IsRequired) {
                return "This field is required";
            }
            return patternErrorMessage;
        });

    }
}

export interface ISignatureProperties {
    isChecked: KnockoutComputed<boolean>;
    signatureDisplay: KnockoutComputed<string>;
}

export class MultipleQuestionAnswerRow {
    adminQuestions: IObservableAdminQuestionDto[];
    remove: () => void;

    constructor(removeRow: () => void, questions: IObservableAdminQuestionDto[]) {
        this.adminQuestions = questions;

        this.remove = removeRow;
    }


}
export interface IEditableQuestionChoice extends IQuestionChoice {
    isOther?: boolean;
}

/**
 * Represents the observable version of an IAnswerToSave
 */
export interface IObservableAnswerToSave {
    QuestionId: Guid;
    QuestionFieldName: string;
    AnswerValue: KnockoutObservable<string>;
    Rows: KnockoutObservableArray<IObservableCompositeAnswerRow>;
}

/**
 * Represents the observable version of an ICompositeAnswerRow
 */
export interface IObservableCompositeAnswerRow {
    RowNumber: number;
    Answers: KnockoutObservableArray<IObservableAnswerToSave>;
}


/**
 * Represents an individual question and the answers assigned to it for a given form response.
 */
export interface IObservableAdminQuestionDto {

    /**
     * The actual question and all of its properties.
     */
    Question: ISurveyQuestion;

    /**
     * The answers that are associated with this question.
     */
    AnswersToSave: KnockoutObservableArray<IObservableAnswerToSave>;

    /**
     * The identifiers of the phases that this question is visible in
     */
    PhaseIds: Guid[];

    /**
     * additional properties to be used when rendering the question.
     */
    renderingProps?: QuestionRenderingProperties;

    /**
     * If a question is meant to have only a single answer value, this computed can be used rather than interacting with the AnswersToSave collection.
     */
    singleAnswerValue?: KnockoutComputed<string>;

    /**
     * Determines whether the answers for this question should be saved when the formResponse is saved to the server.
     */
    shouldSaveAnswers: KnockoutObservable<boolean>;

    /**
     * Determines if this question is visible in the given phase.
     * @param phaseId The identifier of the phase to check if this question is associated with it.
     * @returns {boolean} A boolean value indicating if this question is associated with the given phase or not.
     */
    hasPhase(phaseId: Guid | string): boolean;

    /**
     * Determines if the question matches the given search filter.
     * @param filter A string containing the search filter.
     * @returns {boolean} A boolean value indicating whether or not the question matches the given search filter.
     */
    matchesFilter(filter: string): boolean;


}



class ObservableAnswerToSave implements IObservableAnswerToSave {

    QuestionId: Guid;
    QuestionFieldName: string;
    AnswerValue: KnockoutObservable<string>;
    Rows: KnockoutObservableArray<IObservableCompositeAnswerRow>;

    constructor(ans: IAnswerToSave) {
        this.QuestionId = ans.QuestionId;
        this.QuestionFieldName = ans.QuestionFieldName;
        this.AnswerValue = ko.observable(ans.AnswerValue);
        this.Rows = ans.Rows && ko.observableArray(ans.Rows.map((value: ICompositeAnswerRow) => { return new ObservableCompositeAnswerRow(value); })) || ko.observableArray<IObservableCompositeAnswerRow>();
    }

}
class ObservableCompositeAnswerRow implements IObservableCompositeAnswerRow {
    RowNumber: number;
    Answers: KnockoutObservableArray<IObservableAnswerToSave>;

    constructor(row?: ICompositeAnswerRow) {
        if (row) {
            this.RowNumber = row.RowNumber;
            this.Answers = row.Answers && ko.observableArray<IObservableAnswerToSave>(row.Answers.map((value: IAnswerToSave) => {
                return new ObservableAnswerToSave(value);
            })) || ko.observableArray<IObservableAnswerToSave>();
        } else {
            this.RowNumber = null;
            this.Answers = ko.observableArray<IObservableAnswerToSave>();
        }
    }
}
export class ObservableAdminQuestionDto implements IObservableAdminQuestionDto {
    Question: ISurveyQuestion;
    AnswersToSave: KnockoutObservableArray<IObservableAnswerToSave>;
    PhaseIds: Guid[];
    renderingProps: QuestionRenderingProperties;
    singleAnswerValue: KnockoutComputed<string>;
    shouldSaveAnswers: KnockoutObservable<boolean>;
    private phaseMap: { [phaseId: string]: boolean };
    pageData: IQuestionRenderingReferenceData;

    constructor(aq: IAdminQuestionDto | ISurveyQuestion, pageData: IQuestionRenderingReferenceData, answersToSave?: KnockoutObservableArray<IObservableAnswerToSave>) {


        this.pageData = pageData;
        if (!pageData) {
            debugger;
        }
        var debugAdRealms = pageData.adRealms;

        if (aq["Question"] === undefined && aq["PhaseIds"] === undefined) {

            var sq = <ISurveyQuestion>aq;
            this.AnswersToSave = answersToSave;
            this.Question = sq;
            this.PhaseIds = [];
            this.shouldSaveAnswers = ko.observable(false);

        } else {

            var iaq = <IAdminQuestionDto>aq;
            this.shouldSaveAnswers = ko.observable(false);
            this.Question = iaq.Question;
            this.PhaseIds = iaq.PhaseIds;
            this.AnswersToSave = iaq.AnswersToSave && ko.observableArray<IObservableAnswerToSave>(iaq.AnswersToSave.map((value: IAnswerToSave) => {
                return new ObservableAnswerToSave(value);
            })) || ko.observableArray<IObservableAnswerToSave>();

        }


        this.addQuestionProperties(this);

        this.phaseMap = {};
        for (var pid of this.PhaseIds) {
            this.phaseMap[<string>pid] = true;
        };

        this.updateChoiceOrder(this);


     

    }
    private updateChoiceOrder(q: ObservableAdminQuestionDto) {
        if (q.Question.QuestionChoices) {
            q.Question.QuestionChoices = _.sortBy(q.Question.QuestionChoices, "DisplayOrder");
        }
    }
    private searchString: string;
    matchesFilter(filter: string) {
        if (!filter) {
            return true;
        }

        if (!this.searchString) {
            // initialize search string
            this.searchString = [this.Question.FieldName, this.Question.QuestionText, this.Question.QuestionType].join(" ").toLowerCase();
        }
        return this.searchString.indexOf(filter) > -1;
    }
    hasPhase(phaseId: Guid | string) {
        return this.phaseMap[<string>phaseId];
    };

    private addQuestionProperties(q: ObservableAdminQuestionDto) {
        q.singleAnswerValue = ko.computed<string>(<KnockoutComputedDefine<string>>{
            read: () => {
                if (q.AnswersToSave() && q.AnswersToSave().length > 0) {
                    return q.AnswersToSave()[0].AnswerValue();
                }
                return null;
            },
            write: (value: string) => {
                if (!q.AnswersToSave) {
                    q.AnswersToSave = ko.observableArray<IObservableAnswerToSave>();
                }
                if (q.AnswersToSave().length < 1) {
                    q.AnswersToSave()[0] = <IObservableAnswerToSave>{
                        AnswerValue: ko.observable(null),
                        QuestionId: q.Question.QuestionId
                    }
                }
                Logger.log(`writing value '${value}' to answer`);
                q.AnswersToSave()[0].AnswerValue(value);
            }
        });
        q.renderingProps = new QuestionRenderingProperties(q, this.pageData);


    }

}

class SignatureAnswerValue {
    checked: boolean;
    dateChecked: moment.Moment;
    username: string;
    static signatureDateFormat: string = "MM/DD/YYYY HH:mm:ss";
    private currentUserName: string;
    constructor(currentUserName: string, checked?: boolean, dateCheckedUtc?: moment.Moment, username?: string) {
        if (_.isBoolean(checked)) {
            this.checked = checked;
        } else {
            this.checked = false;
        }
        if (dateCheckedUtc) {
            this.dateChecked = dateCheckedUtc;
        }
        if (username) {
            this.username = username;
        }
    }

    toString() {
        return `${this.checked}|${this.username ? this.username : this.currentUserName}|${this.dateChecked ? this.dateChecked.utc().format(SignatureAnswerValue.signatureDateFormat) : ""}`;
    }

}

class CourseCrnAnswerValue {
    termCode: string;
    crn: string;

    constructor(crn: string, termCode: string) {
        if (termCode && crn) {
            this.termCode = termCode;
            this.crn = crn;
        }
    }

    toString() {
        return `${this.crn}|${this.termCode}`;
    }

}

export interface IQuestionRenderingReferenceData
{
    adRealms: IAvailableActiveDirectoryRealms;
    eventSessionCategories: IEventSessionCategoryDto[];
    eventSessions: IEditEventSessionDto[];
    formResponseId: Guid;
    currentUserName: string;
    documents: IDocumentDto[];
    downloadFileUrl: string;
    courseCrnQuestionModel: ICourseCrnQuestionModel;
}

export class QuestionRenderingProperties {
    public questionInputId: string;
    public containerClass: KnockoutComputed<string>;
    public specificValidationType: FormBuilder.SpecificValidationType;

    public hasError: KnockoutComputed<boolean>;
    public errorMessage: KnockoutComputed<string>;

    public dateTimeQuestionProperties: DateTimeQuestionProperties;
    public singleLineTextQuestionProperties: SingleLineTextQuestionProperties;
    public multiLineTextQuestionProperties: MultiLineTextQuestionProperties;
    public numberQuestionProperties: NumberQuestionProperties;
    public checkboxQuestionProperties: ICheckboxQuestionProperties;
    public choiceProperties: ChoiceProperties;
    public fileUploadProperties: FileUploadProperties;
    public compositeProperties: IMultipleQuestionAnswerProperties;
    public guestProperties: IGuestQuestionAnswerProperties;
    public signatureProperties: ISignatureProperties;
    public eventSessionProperties: IEventSessionProperties;
    public netIdQuestionProperties: NetIdQuestionProperties;
    public personAttributeQuestionProperties: PersonAttributeQuestionProperties;
    public courseCrnQuestionProperties: CourseCrnQuestionProperties;
    constructor(q: ObservableAdminQuestionDto, pageData: IQuestionRenderingReferenceData) {
        var index = SerialGenerator.getSerial();
        this.questionInputId = "Q_" + index;

        let innerContainerClass = "form-group";

        var rolledUpValidationRule = this.rollUpValidationRules(q.Question.QuestionValidations);
        if (rolledUpValidationRule) {
            this.specificValidationType = rolledUpValidationRule.SpecificValidationType;
        }

        var qt = q.Question.QuestionType;
        var isChoiceBased = (qt === "CheckBoxList" || qt === "DropDownList" || qt === "RadioButtonList" || qt === "SelectList");

        let innerErrorProp: KnockoutComputed<boolean> = null;

        let innerErrorMessage: KnockoutComputed<string> = null;

        this.errorMessage = ko.pureComputed(() => {
            if (innerErrorMessage) {
                return innerErrorMessage();
            }
            return null;
        });
        this.hasError = ko.pureComputed(() => {
            if (innerErrorProp) {
                return innerErrorProp();
            }
            return false;
        });

        var typ: string;

        if (isChoiceBased) {
            this.choiceProperties = new ChoiceProperties(q);
            innerErrorProp = this.choiceProperties.hasError;
            innerErrorMessage = this.choiceProperties.errorMessage;

        }
        if (qt === "NetId") {
            this.netIdQuestionProperties = new NetIdQuestionProperties(q, pageData.adRealms);
            innerErrorProp = this.netIdQuestionProperties.hasError;
            innerErrorMessage = this.netIdQuestionProperties.errorMessage;

        }
        if (qt === "PersonAttribute") {
            this.personAttributeQuestionProperties = new PersonAttributeQuestionProperties(q);
        }
        if (qt === "EventSession") {
            this.eventSessionProperties = new EventSessionProperties(q, pageData.eventSessionCategories, pageData.eventSessions, pageData.formResponseId);
        }

        if (qt === "Guest") {
            //IGuestQuestionAnswerProperties
            this.guestProperties = new GuestQuestionAnswerProperties(q, this.specificValidationType);
            innerErrorProp = this.guestProperties.hasError;
            innerErrorMessage = this.guestProperties.errorMessage;


        }
        if (qt === "MultipleQuestionAnswer") {

            this.compositeProperties = new MultipleQuestionAnswerProperties(q);
        }
        if (qt === "Signature") {

            var parseBoolean = (st: string) => {
                if (st && st.length) {
                    st = st.toLowerCase().trim();
                    if (st === "true") {
                        return true;
                    } else if (st === "false") {
                        return false;
                    }
                }
                return null;
            }

            var signatureDateFormat = SignatureAnswerValue.signatureDateFormat;

            var parseSignatureAnswerValue = (answerValue: string) => {
                Logger.log(`parsing signature answer value of "${answerValue}"`);
                if (answerValue && answerValue.length) {
                    var values = answerValue.split("|");
                    if (values && values.length === 3) {
                        var isChecked = parseBoolean(values[0]);
                        if (_.isBoolean(isChecked)) {
                            if (isChecked) {
                                var username = values[1];

                                var m = moment.utc(values[2], signatureDateFormat);
                                if (m.isValid()) {
                                    m = m.local();
                                    return new SignatureAnswerValue(pageData.currentUserName, isChecked, m, username);
                                }
                            }
                        }
                    }
                }
                return new SignatureAnswerValue(pageData.currentUserName);
            }
            var originalAnswerValue = q.singleAnswerValue();
            var originalSignature = parseSignatureAnswerValue(originalAnswerValue);

            var parsedSignatureAnswerValue = ko.pureComputed<SignatureAnswerValue>(() => {
                return parseSignatureAnswerValue(q.singleAnswerValue());
            });

            this.signatureProperties = <ISignatureProperties>{
                isChecked: ko.computed<boolean>(<KnockoutComputedDefine<boolean>>{
                    read: () => {
                        var av = parsedSignatureAnswerValue();
                        return av.checked;
                    },
                    write: (value: boolean) => {

                        if (value && originalSignature.checked) {
                            q.singleAnswerValue(originalAnswerValue);
                        } else {
                            var sav = new SignatureAnswerValue(pageData.currentUserName, value, moment(), "");
                            q.singleAnswerValue(sav.toString());
                        }


                    }
                }),
                signatureDisplay: ko.computed<string>(() => {
                    var av = parsedSignatureAnswerValue();
                    if (av.checked) {
                        return `Signed by ${av.username} on ${av.dateChecked.local().format("YYYY-MM-DD hh:mm:ss a")}`;
                    }
                    return null;
                })
            };
        }
        if (qt === "FileUpload") {
            this.fileUploadProperties = new FileUploadProperties(q, pageData.documents, pageData.downloadFileUrl);
        }
        if (qt === "CheckBox") {
            innerContainerClass = "checkbox";
            this.checkboxQuestionProperties = <ICheckboxQuestionProperties>{
                booleanValue: ko.computed<boolean>(<KnockoutComputedDefine<boolean>>{
                    read: () => {
                        if (q.singleAnswerValue()) {
                            return q.singleAnswerValue().toLowerCase() === "true";
                        }
                        return false;
                    },
                    write: (value: boolean) => {
                        if (value !== null) {
                            q.singleAnswerValue(String(value));
                        } else {
                            q.singleAnswerValue(null);
                        }
                    }
                })
            };
        }

        if (qt === "SingleLineText") {
            this.singleLineTextQuestionProperties = new SingleLineTextQuestionProperties(q);
            innerErrorProp = this.singleLineTextQuestionProperties.hasError;
            innerErrorMessage = this.singleLineTextQuestionProperties.errorMessage;
        }
        if (qt === "MultiLineText") {
            this.multiLineTextQuestionProperties = new MultiLineTextQuestionProperties(q);
            innerErrorProp = this.multiLineTextQuestionProperties.hasError;
            innerErrorMessage = this.multiLineTextQuestionProperties.errorMessage;
        }

        if (qt === "Number") {
            this.numberQuestionProperties = new NumberQuestionProperties(q);
            innerErrorProp = this.numberQuestionProperties.hasError;
            innerErrorMessage = this.numberQuestionProperties.errorMessage;
        }

        if (qt === "DateTime") {
            this.dateTimeQuestionProperties = new DateTimeQuestionProperties(q);
            innerErrorProp = this.dateTimeQuestionProperties.hasError;
            innerErrorMessage = this.dateTimeQuestionProperties.errorMessage;

        }

        if (qt === "CourseCrn") {
            this.courseCrnQuestionProperties = new CourseCrnQuestionProperties(q, pageData.courseCrnQuestionModel);
            innerErrorProp = this.courseCrnQuestionProperties.hasError;
            innerErrorMessage = this.courseCrnQuestionProperties.errorMessage;
        }

        this.containerClass = ko.pureComputed(() => {
            if (this.hasError()) {
                return `${innerContainerClass} has-warning`;
            }
            return innerContainerClass;
        });
    }




    normalizeGuid(id: string | Guid): string {
        return Util.normalizeGuid(id);
    }

    rollUpValidationRules(validations: IQuestionValidation[]): IQuestionValidation {
        return Util.rollUpValidationRules(null, validations);
    }

}

